import styled from "styled-components";

export const AdvantageCard = styled.div`
  width: calc(50% - 5px);
  height: 16.5rem;
  padding: 3.125rem;
  border: 4px solid hsl(227.83deg 52.01% 68.89% / 99.2%);

  .card__top {
    display: flex;
    align-items: center;
    margin-bottom: 1.875rem;

    & img {
      margin-right: 1.25rem;
    }
  }

  @media(max-width:1330px){
    padding: 2.125rem;
  }
  @media(max-width:1145px){
    padding: 1.125rem;
  }

  @media(max-width:999px){
    width: 100%;
    padding: 3.125rem;
     height: auto;
  }
  @media(max-width:768px){
     padding: 1.125rem;
  }

  @media(max-width:370px){
     padding: 0.7rem;

     .card__top {
      margin-bottom: 1rem;
     }
  }
`;
